import { render, staticRenderFns } from "./FundMapCategoryMapRelocateBox.vue?vue&type=template&id=6dc608be&scoped=true"
import script from "./FundMapCategoryMapRelocateBox.vue?vue&type=script&lang=js"
export * from "./FundMapCategoryMapRelocateBox.vue?vue&type=script&lang=js"
import style0 from "./FundMapCategoryMapRelocateBox.vue?vue&type=style&index=0&id=6dc608be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc608be",
  null
  
)

export default component.exports